import { B2B_URL } from './constans';
import { NavigationMenuItem } from '../../models/NavigationMenuItem';

export const SIDEBAR_PROFILE_NAVIGATION: NavigationMenuItem = {
    id: 'sidebar-menu',
    resourceId: null,
    title: null,
    type: null,
    url: null,
    items: [
        {
            id: 'profile',
            resourceId: null,
            title: 'SIDEBAR_ITEMS.PROFILE',
            translateTitle: true,
            type: 'ROUTE',
            url: '/profile',
        },

        {
            id: 'account',
            resourceId: null,
            title: 'SIDEBAR_ITEMS.ACCOUNT',
            translateTitle: true,
            type: 'PAGE',
            url: B2B_URL + '/account',
        },
        {
            id: 'invoices',
            resourceId: null,
            title: 'SIDEBAR_ITEMS.INVOICES',
            translateTitle: true,
            type: 'ROUTE',
            url: '/invoices',
        },
        // {
        //     id: 'live_orders',
        //     resourceId: null,
        //     title: 'HEADER.LIVE_ORDERS',
        //     translateTitle: true,
        //     showOnlyOnMobile: false,
        //     type: 'ROUTE',
        //     url: '/live-orders',
        // },
        {
            id: 'shop',
            resourceId: null,
            title: 'HEADER.SHOP',
            translateTitle: true,
            showOnlyOnMobile: true,
            type: 'PAGE',
            url: B2B_URL,
        },
        {
            id: 'logout',
            resourceId: null,
            title: 'SIDEBAR_ITEMS.LOGOUT',
            translateTitle: true,
            type: 'ROUTE',
            url: '/logout',
        },
    ],
};

export const SIDEBAR_ADMIN_NAVIGATION: NavigationMenuItem = {
    id: 'admin-menu',
    resourceId: null,
    title: null,
    type: null,
    url: null,
    items: [
        {
            id: 'users',
            resourceId: null,
            title: 'HEADER.USERS',
            translateTitle: true,
            type: 'ROUTE',
            url: '/admin/users',
        },
        {
            id: 'add-partner',
            resourceId: null,
            title: 'HEADER.ADD_PARTNER',
            translateTitle: true,
            type: 'ROUTE',
            url: '/admin/add-partner',
        },
        // {
        //     id: 'products-management',
        //     resourceId: null,
        //     title: 'HEADER.PRODUCTS_MANAGEMENT',
        //     translateTitle: true,
        //     type: 'ROUTE',
        //     url: '/admin/products-management',
        // },
    ],
};

export const SIDEBAR_QUOTATION_NAVIGATION: NavigationMenuItem = {
    id: 'quotation-menu',
    resourceId: null,
    title: null,
    type: null,
    url: null,
    items: [
        {
            id: 'quotations',
            resourceId: null,
            title: 'HEADER.QUOTATION_THIRD_MEMBER',
            translateTitle: true,
            type: 'ROUTE',
            url: '/quotations',
        },
        {
            id: 'my-quotations',
            resourceId: null,
            title: 'HEADER.MY_QUOTATION',
            translateTitle: true,
            type: 'ROUTE',
            url: '/my-quotations',
        },
    ],
};
